import { createSelector } from '@ngrx/store';

import { getCartOrderTypeId } from '@shared/state/cart/selectors';
import { getOrderTypeId } from '@shared/state/collectionType/selectors';

/**
 * Get orderTypeId from cart or from collectionType state
 */
export const getOrderTypeIdFromDefaultOrCart = createSelector(getCartOrderTypeId, getOrderTypeId, (cartOrderTypeId, defaultOrderTypeId) => cartOrderTypeId || defaultOrderTypeId);
